import { Box, Button, Grid2 } from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import ContactPersonTable from './ContactPersonTable'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Grid_Gap } from '../../shared/constants'
import { useMutation, useQueryClient } from '@tanstack/react-query'
// import api from '../../assets/api/useStudentPostApi'
import useAuthStore from '../../store/useAuthStore'
import { TextFormField } from '../../shared/components/formfields/TextFormField'
import { useToaster } from '../../shared/utils/ToasterProvider'
import { PhoneInputFormField } from '../../shared/components/formfields/PhoneInputFormField'
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField'
import useContactPersonStore from '../../store/useContactPersonStore'
import { useAllApartmentss } from './FetchAllApartment'
import { isValidPhoneNumber } from 'react-phone-number-input'
import useContactPersonListStore from '../../store/userContactPersonListStore'
import api from '../../assets/nodeApi/axiosInstance'
export const designationOption = [
    { id: 1, label: "Apartment Owner", value: "Apartment Owner" },
    { id: 2, label: "Tenant/Renter", value: "Tenant/Renter" },
    { id: 3, label: "Association President", value: "Association President" },
    { id: 4, label: "Secretary", value: "Secretary" },
    { id: 5, label: "Treasurer", value: "Treasurer" },
    { id: 6, label: "Committee Members", value: "Committee Members" },
    { id: 7, label: "Property Manager", value: "Property Manager" }
];

const ContactPersonList = ({ apartment_id }) => {
    const { contactperson, clearContactperson } = useContactPersonStore()
    const {
        contactpersonList,
        setContactpersonList,
        clearContactpersonList,
    } = useContactPersonListStore();
    const { token, user } = useAuthStore()
    const { showToaster } = useToaster();
    const queryClient = useQueryClient();
    const { data: allApartment, isLoading } = useAllApartmentss();
    const ApartmentOption = allApartment
        ?.filter(item => item?.id === apartment_id)
        .map((item, index) => ({
            id: item?.id || index + 1,
            value: item?.apartment_name,
            label: item?.apartment_name
        })) || [];
    const validationSchema = Yup.object().shape({
        // apartment_id: Yup.string().required('Apartment ID is required'),
        name: Yup.string().required('Name is required'),
        mobile_no: Yup.string().test(
            "is-phone",
            "Phone number is not valid",
            (value) => value && isValidPhoneNumber(value)
        ).required("Mobile Number is required"),
        email: Yup.string().email('Invalid email').required('Email is required'),
        designation: Yup.string().required('Designation is required'),
    });
    const initialValues = {
        // apartment_id: contactperson?.apartment_id || "",
        name: contactperson?.name || "",
        mobile_no: contactperson?.mobile_no || "",
        email: contactperson?.email || "",
        designation: contactperson?.designation || ""
    };


    const mutation = useMutation({
        mutationFn: (formData) => {
            return api.post(`apartment/contact-persons`, formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
        },
        onSuccess: (response) => {
            showToaster('Success', response?.data?.message, 'success')
            queryClient.invalidateQueries({ queryKey: ['all-collab-apartment-details'] });
            queryClient.invalidateQueries({ queryKey: ['collab-apartment-details-list'] });
            clearContactperson()
        },
        onError: (error) => {
            showToaster(error?.response?.data?.message || "Something Went wrong", 'Error', 'error')
        },
    });
    const handleSubmit = (values, { resetForm }) => {
        setContactpersonList(values)
        resetForm()
    }

    const handleAddContactPerson = () => {
        if (contactpersonList?.length > 0) {
            const formData = {
                apartment_id: apartment_id,
                contacts: contactpersonList
            };
            mutation.mutate(formData, {
                onSuccess: () => {
                    clearContactpersonList();
                }
            });
        } else {
            showToaster('Please add at least one contact person', 'Error', 'error');
        }
    }

    return (
        <Box>

            <CustomDivider />

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize={true}
            >
                {({ resetForm }) => (
                    <Form>
                        <NormalContainerWithHeader headerText={"Contact Person List"}

                        >
                            <Grid2 container spacing={Grid_Gap}>
                                {/* <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Field
                                        name="apartment_id"
                                        component={IdAutoCompleteField}
                                        value={ApartmentOption?.value}
                                        options={ApartmentOption}
                                        label="Select Apartment"
                                        isRequired={true}
                                        isLoading={isLoading}

                                    />
                                </Grid2> */}
                                <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Field
                                        name="name"
                                        component={TextFormField}
                                        label="Name"
                                        isRequired={true}

                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Field
                                        name="mobile_no"
                                        component={PhoneInputFormField}
                                        label="Mobile No"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Field
                                        name="email"
                                        component={TextFormField}
                                        label="Email"
                                        isRequired={true}

                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Field
                                        name="designation"
                                        component={AutoCompleteField}
                                        options={designationOption}
                                        label="Designation"
                                        isRequired={true}

                                    />
                                </Grid2>
                                <CustomDivider />

                            </Grid2>

                            <CustomDivider />
                            
                            <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                                <Button variant='outlined' type="submit" fullWidth>Add Contact Person</Button>
                            </Grid2>


                            <CustomDivider />
                            <ContactPersonTable />
                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Button fullWidth variant="outlined" onClick={() => { resetForm(); clearContactpersonList() }} > Clear </Button>
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Button fullWidth variant="contained" onClick={handleAddContactPerson}>
                                        Submit
                                    </Button>
                                </Grid2>
                            </Grid2>
                            <CustomDivider />

                        </NormalContainerWithHeader>
                    </Form>
                )}
            </Formik>
            <CustomDivider />
            {/* </NormalContainerWithHeader> */}
            <CustomDivider orientation='horizontal' />


        </Box>
    )
}

export default ContactPersonList